
// 系统环境参数
let systemKey = "student-pc"
let domain = process.env.NODE_ENV=="development" ? "https://t.dailyedu.com":location.protocol + "//" + location.host
// let domain = "https://www.dailyedu.com"
let domainApi = `${domain}/api`
// let domainManageApi = `${domain}/manage-api`
let domainManageApi = `${domain}/api`
let wxDomain = "https://wx.dailyedu.com.cn"
const WITSBOX_ENV_PARAM = {
		timeStart:1722268800000, // 1722355200000
		freeLearningCardArr:[
					{
						days: 30,
						name: '月卡',
						price: 69,
						amount: 69,
						type: 'month'
					},
					{
						days: 90,
						name: '季卡',
						price: 199,
						amount: 199,
						type: 'season'
					},
					{
						days: 180,
						name: '半年卡',
						price: 369,
						amount: 369,
						type: 'half-year'
					}
				],
	crmApi:domain+'/daiencrm/prod-api',
  domain: domain,
  IMAccountPrefix: domain == 'https://t.witsbox.com'||domain == 'https://t.dailyedu.com' ? 'test' : 'prod', 
  systemKey: systemKey,
  baseUrl: domainApi,
	baseUrlManage: domainManageApi,
  saleUrl: `https://wx.dailyedu.com.cn/sale/#`,
  examUrl: `${domain}/exam`,
  neoUrl: `${domain}/neo`,
  hostUrl: process.env.NODE_ENV=="development" ? "http://localhost:8082/#":`${domain}/${systemKey}/#`,
  classroom: `${domain}/classroom/html`,
  studentMbUrl: `${wxDomain}/student-mb`,  //通过扫码打开移动端
  loginPage: `${domain}/${systemKey}/`,
  competitionUrl: `${domain}/competition/#`,
  ossObject: {},
  client: {},
	levelOptions: {
	    0: 0,
	    1: 100,
	    2: 400,
	    3: 1400,
	    4: 4400,
	    5: 9400,
	    6: 21000,
	    7: 45000,
	    8: 81000,
	    9: 129000,
	    10: 189000,
	    11: 261000,
	    12: 345000,
	    13: 441000,
	    14: 549000,
	    15: 629000,
		16: 800000,
	    17: 1000000,
	},
}
export default WITSBOX_ENV_PARAM



// WEBPACK FOOTER //
// ./utils/common.js